<form class="d-flex flex-column mt-3" [formGroup]="queryForm">
  <div class="row">
    <div class="col">
      <div [hidden]="!flagPermessoVisibilityQuery" class="visibility">
        <mat-slide-toggle formControlName="visibility">
          <span class="visibility-text">{{ 'map.sidebar.query.set_public' | translate }}</span>
        </mat-slide-toggle>
        <mat-icon class="visibility-eye">{{ queryForm.get('visibility').value ? 'visibility' :
          'visibility_off'}}</mat-icon>
      </div>
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>{{'map.sidebar.query.name_query' | translate}}</mat-label>
        <input matInput placeholder="Placeholder" formControlName="query_name" required>
        <mat-error *ngIf="queryForm.get('query_name').invalid">{{'common.required_field' | translate}}</mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="my-3">
    <h5 class="my-2">{{'map.sidebar.query.select_dataset_and_table' | translate}}</h5>
  </div>

  <div class="row mb-3">
    <div class="col-12 mb-3" [ngClass]="{'col': advanced}">
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>{{'map.sidebar.query.dataset' | translate}}</mat-label>
        <mat-select formControlName="dataset" required (selectionChange)="getFromDataset($event.value, true)">
          <mat-option *ngFor="let dataset of datasetList" [value]="dataset.name">
            {{dataset.label}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="queryForm.get('dataset').invalid">{{'common.required_field' | translate}}</mat-error>
      </mat-form-field>
    </div>
    <div class="col-12 mb-3" *ngIf="!advanced">
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>{{'map.sidebar.query.table' | translate}}</mat-label>
        <mat-select formControlName="table_name" required (selectionChange)="onTableChange($event.value)">
          <mat-option *ngFor="let table of queryTableList" [value]="table.name">
            {{table.label}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="queryForm.get('table_name').invalid">{{'common.required_field' | translate}}</mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="row mb-3" *ngIf="advanced;else standard">
    <div class="col">
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>{{'map.sidebar.query.query_script' | translate}}</mat-label>
        <textarea matInput placeholder="FGN C Allacciamento Privato| WHERE |Asse| within trail plus"
          formControlName="query_script"></textarea>
        <mat-error *ngIf="queryForm.get('query_script').invalid">{{'common.required_field' | translate}}</mat-error>
        <button mat-icon-button matSuffix color="primary" [matTooltip]="'map.sidebar.query.insert_geometry' | translate"
          *ngIf="showAdvancedTrail && listConditions.controls.length == 0" (click)="getGeometryOnMap()">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button matSuffix color="primary" [matTooltip]="'map.sidebar.query.remove_geometry' | translate"
          *ngIf="showAdvancedTrail && listConditions.controls.length == 1" (click)="removeGeometry()">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-form-field>
      <mat-hint class="green" *ngIf="showAdvancedTrail && listConditions.controls.length == 1">
        {{'map.sidebar.query.success_insert_geometry' | translate}}</mat-hint>
    </div>
  </div>
  <ng-template #standard>
    <div class="my-3">
      <h5 class="my-2">{{'map.sidebar.query.query_section' | translate}}</h5>
    </div>
    <mat-accordion class="mb-1 p-1">
      <mat-expansion-panel class="condition-panel" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h5 class="m-0">{{'map.sidebar.query.set_conditions' | translate}}</h5>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container formArrayName="asset_query_cond">
          <div *ngFor="let _ of listConditions.controls; index as i" class="conditionBlock">
            <ng-container [formGroupName]="i">
              <div class="d-flex justify-content-between">
                <div class="p-2">
                  <mat-chip-set aria-label="Operator selection" *ngIf="i >= 1">
                    <mat-chip-option color="primary" [selected]="_['controls']['operator'].value == 'AND'"
                      (click)="changeSelected(enumOperator.AND,i)">
                      {{enumOperator.AND}}</mat-chip-option>
                    <mat-chip-option color="accent" [selected]="_['controls']['operator'].value == 'OR'"
                      (click)="changeSelected(enumOperator.OR,i)">
                      {{enumOperator.OR}}</mat-chip-option>
                  </mat-chip-set>
                </div>
                <div class="ml-auto p-2">
                  <button mat-icon-button (click)="removeCodition(i)">
                    <mat-icon>
                      <span class="material-symbols-outlined fs-20">
                        delete
                      </span>
                    </mat-icon>
                  </button>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col">
                  <mat-form-field appearance="outline" class="w-100 mb-2">
                    <mat-label>{{'map.sidebar.query.field' | translate}}</mat-label>
                    <mat-select formControlName="field" (selectionChange)="conditionFieldChanged($event.value,i)" required>
                      <mat-option *ngFor="let field of fields" [value]="field.name">
                        {{ field.label }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="_.get('field').invalid">{{'common.required_field' | translate}}</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12 mb-3">
                  <mat-form-field appearance="outline" class="w-100 mb-2">
                    <mat-label>{{'map.sidebar.query.condition' | translate}}</mat-label>
                    <mat-select formControlName="comparison" required>
                      <mat-option
                        *ngFor="let cond of conditions | filter: listConditions.controls[i].get('field_type').value:'type'"
                        [value]="cond.name">
                        {{ cond.label }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="_.get('comparison').invalid">{{'common.required_field' | translate}}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-12 mb-3">
                  <ng-container *ngIf="_['controls']['comparison'].value=='within'; else inputBlock">
                    <button mat-icon-button color="accent" (click)="getGeometryOnMap()">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <mat-error *ngIf="_.get('value').invalid">{{'common.required_field' | translate}}
                    </mat-error>
                  </ng-container>

                  <ng-template #inputBlock>
                    <mat-form-field appearance="outline" class="w-100 mb-2">
                      <mat-label>{{'map.sidebar.query.value' | translate}}</mat-label>
                      <input matInput formControlName="value" required>
                      <mat-error *ngIf="_.get('value').invalid">{{'common.required_field' | translate}}
                      </mat-error>
                    </mat-form-field>
                  </ng-template>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <div class="d-flex justify-content-center">
          <button mat-flat-button (click)="addCondition()" color="accent">
            <mat-icon>add</mat-icon>
            <span>{{'map.sidebar.query.add_condition' | translate}}</span>
          </button>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion class="mb-1 p-1">
      <mat-expansion-panel class="condition-panel" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h5 class="m-0">{{'map.sidebar.query.order_by_results' | translate}}</h5>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container formArrayName="asset_query_ord">
          <div *ngFor="let _ of listOrders.controls; index as i" class="conditionBlock">
            <ng-container [formGroupName]="i">
              <div class="row mb-3">
                <div class="col">
                  <mat-form-field appearance="outline" class="w-100 mb-2">
                    <mat-label>{{'map.sidebar.query.order_by' | translate}}</mat-label>
                    <mat-select formControlName="field" (selectionChange)="orderFieldChanged($event.value,i)" required>
                      <mat-option *ngFor="let field of fields" [value]="field.name">
                        {{field.label}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="_.get('field').invalid">{{'common.required_field' | translate}}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="d-flex justify-content-between mb-3">
                <mat-chip-set aria-label="Operator selection">
                  <mat-chip-option color="primary" [selected]="_['controls']['value'].value == 'ascending'"
                    (click)="changeOrder('ascending',i)">
                    {{enumOrder.ASC}}</mat-chip-option>
                  <mat-chip-option color="accent" [selected]="_['controls']['value'].value == 'descending'"
                    (click)="changeOrder('descending',i)">
                    {{enumOrder.DESC}}</mat-chip-option>
                </mat-chip-set>
                <div class="ml-auto">
                  <button mat-icon-button (click)="removeOrder(i)">
                    <mat-icon>
                      <span class="material-symbols-outlined fs-20">
                        delete
                      </span>
                    </mat-icon>
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <div class="d-flex justify-content-center">
          <button mat-flat-button (click)="addOrder()" color="accent">
            <mat-icon>add</mat-icon>
            <span>{{'map.sidebar.query.add_condition' | translate}}</span>
          </button>
        </div>
      </mat-expansion-panel>
      <div class="pt-2 pb-2">
        <mat-label>
          {{'map.sidebar.query.data_modifica' | translate}}
          {{queryForm.get('date_modified').value | date:"dd/MM/yyyy HH:mm:ss"}}
        </mat-label>
      </div>
    </mat-accordion>
  </ng-template>
</form>